/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import AffiliateLogo from 'bundles/ent-website/components/AffiliateLogo';

import logo from 'images/ent-website/social-impact-logo.svg';

import _t from 'i18n!nls/ent-website';

function SocialImpactLogo() {
  const styles = {
    root: css`
      display: flex;
      flex-direction: row;
      align-items: center;
    `,
  };

  return (
    <div css={styles.root}>
      <img src={logo} width={240} alt={_t('Social Impact Logo')} />
      <AffiliateLogo />
    </div>
  );
}

export default SocialImpactLogo;
